<div class="activity-details solo">
    <!--<div class="child" c-activity-message activity="activity"></div>-->

    <c-auto-form config="setDocflowConfigCtrl.autoFormConfig"></c-auto-form>
</div>